import axiosClient from "./axiosClient";

function toQueryString(params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export async function getStoreCommissionSummary() {
  const response = await axiosClient.get("/store-fees/commission");
  return response.data;
}

export async function getStoreFeeRequests(status) {
  const response = await axiosClient.get(`/store-fees/requests${toQueryString({ status })}`);
  return response.data;
}

export async function confirmStoreFeeSent(settlementId) {
  const response = await axiosClient.post(`/store-fees/requests/${settlementId}/confirm-sent`);
  return response.data;
}

export async function confirmStoreFeeSentBulk(settlementIds) {
  const response = await axiosClient.post(`/store-fees/requests/confirm-sent-bulk`, { settlementIds });
  return response.data;
}
